import { useNavigate } from "react-router-dom";

import { Header } from "../Header";
import { Container, ContainerDevice, FinishAppButton } from "./styles";

export function DeviceNotFoundComponent() {
  const navigate = useNavigate();
  const ip = localStorage.getItem("deviceIp");

  return (
    <>
      {/* <Header /> */}
      <Container>
        <ContainerDevice>
          <div className="deviceNotFoundHeader">
            <span id="deviceNotFoundTitle">Dispositivo não autorizado</span>
          </div>
          <div className="deviceNotFoundSubtitle">
            <span>
              Contate um administrador e informe o IP
              <strong>
                <u> {ip}</u>
              </strong>
            </span>
          </div>
          <div className="deviceNotFoundButtonContainer">
            <FinishAppButton
              id="deviceNotFoundButton"
              type="button"
              onClick={() => {
                navigate("/");
                localStorage.removeItem("deviceIp");
              }}
            >
              Tentar Novamente
            </FinishAppButton>
          </div>
        </ContainerDevice>
      </Container>
    </>
  );
}
